import { useEffect, useState, useMemo, useCallback } from 'react';
import {
  get as getRequest,
  post as postRequest,
  download as downloadRequest,
  token,
} from 'services/api';

export const useApi = () => {
  const [request, setRequest] = useState(null);
  const [source] = useState(token.source());

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  useEffect(() => {
    if (request) {
      const { type, endpoint, params, handlers, configs } = request;
      const cfg = {
        ...configs,
        cancelToken: source.token,
      };

      if (type === 'get') {
        getRequest(endpoint, params, handlers, cfg);
      } else if (type === 'post') {

        postRequest(endpoint, params, handlers, cfg);
      } else if (type === 'download') {
        downloadRequest(endpoint, params, handlers, cfg);
      }
    }
  }, [request]);

  const get = useCallback((endpoint, params, handlers, configs = {}) => {
    setRequest({ type: 'get', endpoint, params, handlers, configs });
  }, []);

  const post = useCallback((endpoint, params, handlers, configs = {}) => {
    setRequest({ type: 'post', endpoint, params, handlers, configs });
  }, []);

  const download = useCallback((endpoint, params, handlers, configs = {}) => {
    setRequest({ type: 'download', endpoint, params, handlers, configs });
  }, []);

  return useMemo(
    () => ({
      get,
      post,
      download,
      getRequest,
      postRequest
    }),
    []
  );
};

export default useApi;
